import { useEffect, useState } from "react";
import SearchMember from "../search-member";
import {
  MileageButtonWrapper,
  MileageHeader,
  MileageMemberWrapper,
  MileagePayMentWrapper,
  MileageWrapper,
} from "./style";
import {
  getMileageMember,
  PubMemberDto,
  chargeMileageMember,
} from "../../../../api/member";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../../recoil/pub.atom";
import MileageHistory from "./components/history";
import MileageBuy from "./components/buy";
import { Title } from "../../../../styles/page";

interface MileagePopupProps {
  onClose: () => void;
}

const MileagePopup = ({ onClose }: MileagePopupProps) => {
  const [selectMember, setSelectMember] = useState<PubMemberDto | null>(null);
  const [buyOpen, setBuyOpen] = useState<boolean>(false);
  const [historyOpen, setHistoryOpen] = useState<boolean>(false);
  const [isPayMent, setIsPayMent] = useState<boolean>(false);
  const [userResultPoint, setUserResultPoint] = useState<number>(0);
  const [payAmount, setPayAmount] = useState<number>(0);
  const pub = useRecoilValue(pubState);

  useEffect(() => {
    if (!selectMember) return;
    setUserResultPoint(selectMember.point);
  }, [selectMember]);

  useEffect(() => {
    if (!selectMember || !payAmount) return;
    const result = selectMember.point + +payAmount;
    setUserResultPoint(isNaN(result) ? selectMember.point : result);
  }, [payAmount, selectMember]);

  const handlePayMent = async () => {
    if (!pub || !selectMember || !payAmount) return;

    if (payAmount <= 0) {
      alert("-는 입력할 수 없습니다. ");
      return;
    }

    const data = {
      memberId: selectMember.memberId,
      pubId: pub.id,
      amount: +payAmount,
    };
    const confirmText = `${payAmount.toLocaleString()}M을 지급 하시겠습니까?`;
    if (window.confirm(confirmText)) {
      try {
        await chargeMileageMember(data);
        alert("마일리지가 충전되었습니다. ");
        setPayAmount(0);
        setUserResultPoint(0);
        setIsPayMent(false);
        getMember();
      } catch (e: any) {
        alert(e.message);
      }
    } else {
    }
  };

  const getMember = async () => {
    if (!pub || !selectMember) return;
    try {
      const res = await getMileageMember(selectMember.nickname, pub.id);
      setSelectMember(res.memberList[0]);
    } catch (error: any) {
      return;
    }
  };

  return (
    <>
      {historyOpen && (
        <MileageHistory
          onClose={() => setHistoryOpen(false)}
          member={selectMember}
          getMember={getMember}
        />
      )}
      {buyOpen && (
        <MileageBuy
          onClose={() => {
            setBuyOpen(false);
            setSelectMember(null);
          }}
          member={selectMember}
        />
      )}
      <MileageWrapper>
        <MileageHeader>
          <Title size={20}>주류 마일리지 관리</Title>
          <img
            src="/image-web/solution/close.svg"
            alt="close"
            onClick={() => onClose()}
          />
        </MileageHeader>
        <SearchMember
          setSelectMember={setSelectMember}
          selectMember={selectMember}
          type={"MILEAGE"}
        />
        {selectMember && (
          <MileageMemberWrapper>
            <div className="header">
              <div className="member">
                {selectMember.nickname}님 보유 주류 마일리지
              </div>
              <div className="point">
                {selectMember.point.toLocaleString()} M
                {!isPayMent && (
                  <img
                    src="/image-web/solution/calender-right-arrow.svg"
                    alt="arrow"
                    onClick={() => {
                      setHistoryOpen(true);
                    }}
                  />
                )}
              </div>
            </div>
            <MileagePayMentWrapper>
              {isPayMent && (
                <>
                  <div className="pay-wrapper">
                    <div className="name">지급 마일리지</div>
                    <input
                      type="text"
                      value={payAmount ? Number(payAmount).toLocaleString() : 0}
                      onChange={(e) => {
                        const rawValue = e.target.value.replace(/[^0-9-]/g, "");
                        setPayAmount(+rawValue);
                      }}
                    />
                  </div>
                  <div className="result-wrapper">
                    <div className="name">적용된 마일리지</div>
                    <div className="value">
                      {userResultPoint.toLocaleString()} M
                    </div>
                  </div>
                </>
              )}
            </MileagePayMentWrapper>
            <MileageButtonWrapper>
              <div
                className={`button ${isPayMent ? "purple" : "gray"}`}
                onClick={() => {
                  if (isPayMent) {
                    handlePayMent();
                  } else {
                    setIsPayMent(true);
                  }
                }}
              >
                {isPayMent ? "적용" : "지급"}
              </div>
              <div
                className={`button ${isPayMent ? "" : "purple"}`}
                onClick={() => {
                  if (isPayMent) {
                    setIsPayMent(false);
                  } else {
                    setBuyOpen(true);
                  }
                }}
              >
                {isPayMent ? "취소" : "구매"}
              </div>
            </MileageButtonWrapper>
          </MileageMemberWrapper>
        )}
      </MileageWrapper>
    </>
  );
};

export default MileagePopup;
